import React, { useCallback } from "react";
import { useHomeData } from "../../../contexts/HomeDataContext";
import { ICity, ProgressState } from "../../../interfaces/home";
import ReferralViewForm from "./ReferralViewForm";
import { ErrorComponent } from "../../errorComponent";
import ReferralViewShimmer from "./ReferralViewShimmer";
import { isValidData } from "utils/object";

const ReferralView = () => {
    const { cities, retryCities } = useHomeData();
    const { state, data } = cities;

    const getStateToRender = useCallback(() => {
        switch (state) {
            case ProgressState.IN_PROGRESS:
                return <ReferralViewShimmer />;
            case ProgressState.FAILED:
                return <ErrorComponent onRetry={retryCities} />;
            case ProgressState.COMPLETED:
                if (!isValidData(data)) {
                    return null;
                }
                return <ReferralViewForm cities={data as ICity[]} />;
            default:
                return null;
        }
    }, [state, retryCities, data]);

    return getStateToRender();
};

export default ReferralView;
